export const roleCombinationsConfig = ({ token }) => ({
  HTTPMethod: "get",
  path: `/api/v1/sso/permissions/revenue-management/role_combinations/cb-pos`,
  queryParams: {},
  headers: {
    Authorization: `Bearer ${token}`,
    Accept: "application/json",
    "Content-Type": "application/json",
  },
  body: {},
});
